import React from 'react';
import { List, Datagrid, TextField, BooleanField, DateField } from 'react-admin';

const WantedCandidatesList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <BooleanField source="is_completed" label="Connected" fullWidth />
      <TextField source="name" label="User Name" fullWidth />
      <TextField source="phone" label="User Phone" fullWidth />
      <TextField source="profile_number" label="Candidate Number" fullWidth />
      <TextField source="contact_method" fullWidth />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export default WantedCandidatesList;
